import { useState, useEffect } from 'react';

/**
 * Debounces a value by the given delay (ms).
 * Usage: const debouncedSearch = useDebounce(search, 300);
 */
const useDebounce = (value, delay = 300) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
